// extracted by mini-css-extract-plugin
export default {"button":"quiz-module--button--f-lzM","results":"quiz-module--results--8Se6J","result":"quiz-module--result--P1nvn","picture":"quiz-module--picture--NGf6S"};